import React, {Component} from "react";
import {connect} from "react-redux";
import {Link} from "react-router";
import {requestRecordPayment, requestCheckPaymentStatus, requestRetryPayment} from "../../actions/AccountApiActions";
import PaymentsList from "../shared/PaymentsList";
import Button from "../../components/Button";
import MetaTable from "../../components/MetaTable";
import Loading from "../../components/Loading";
import Conditional from "../../components/Conditional";
import GraphQLErrors from "../../components/GraphQLErrors";
import {formatSalesOrderStatus} from "../../lib/SalesOrderStatus";
import {dateWithTimeFormat} from "../../lib/DateFormatter";
import gql from "graphql-tag";
import {fromJS} from "immutable";
import {graphql} from "react-apollo";


class ChargePaymentsView extends Component {

  render() {
    let {loading, error} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />        
    const charge = fromJS(this.props.data.billingChargeForSalesOrder);

    return (
      <div>
        <MetaTable>
          <tr>
            <th>Order Id</th>
            <td><Link to={`/sales/orders/${this.props.salesOrderId}`}>{this.props.salesOrderId}</Link></td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{formatSalesOrderStatus(charge.get("status"))}</td>
          </tr>
          <Conditional show={charge.get("status") === "failed"}>
            <tr>
              <th>Last attempt</th>
              <td>{dateWithTimeFormat(charge.get("lastAttemptedAt"))}</td>
            </tr>
            <tr>
              <th>Error</th>
              <td>{charge.get("lastErrorMessage")} ({charge.get("lastErrorCode")})</td>
            </tr>
            <tr>
              <th>Decline code</th>
              <td>{charge.get("lastDeclineCode")}</td>
            </tr>
          </Conditional>
          <Conditional show={charge.get("status") === "failed" && charge.get("willRetry")}>
            <tr>
              <th>Retry</th>
              <td>Will retry on {dateWithTimeFormat(charge.get("retryAt"))}</td>
            </tr>
            <tr>
              <th>Failed attempts</th>
              <td>{charge.get("failedAttempts")}</td>
            </tr>
          </Conditional>
        </MetaTable>
        <PaymentsList
          accountId={this.props.accountId}
          salesOrderId={this.props.salesOrderId}
          />
        <div className="buttons">
          <Button label="Record Payment" onClick={this.handleRecordPayment.bind(this)} />
          <Button label="Check for Payment" primary={false} onClick={this.handleCheckForPayment.bind(this)} />
          <Button label="Retry Payment" onClick={this.handleRetryPayment.bind(this)} primary={false} active={charge.get("status") === "failed"} />
        </div>
      </div>
    )
  }

  handleRecordPayment() {
    this.props.requestRecordPayment(this.props.accountId, this.props.salesOrderId);
  }

  handleCheckForPayment() {
    this.props.requestCheckPaymentStatus(this.props.salesOrderId);
  }

  handleRetryPayment() {
    this.props.requestRetryPayment(this.props.salesOrderId);
  }

}

const CHARGE_INFO = gql`
  query charge($salesOrderId: ID!) {
    billingChargeForSalesOrder(salesOrderId: $salesOrderId) {
      kind
      status
      lastErrorCode
      lastDeclineCode
      lastErrorMessage
      willRetry
      retryAt
      failedAttempts
      lastAttemptedAt
      createdAt
    }
  }
`

const withQuery = graphql(CHARGE_INFO, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      salesOrderId: props.salesOrderId
    }
  })
})


export default connect(null, {
  requestRecordPayment,
  requestCheckPaymentStatus,
  requestRetryPayment  
})(withQuery(ChargePaymentsView));